<i18n>
{
    "en": {
        "title": "Rhythm*IZ Registeration",
        "incompatibleBrowser": "If you have problems signing-in, please try again using Chrome browser.",
        "email": "Email",
        "downloadLink": "Download link",
        "registerButton": "Register",
        "registerButtonComplete": "Registered",
        "registrationComplete": "Registration complete! Open the Google Drive link above to download game and additional resources.",
        "telegram1": "If you have Telegram installed, you can also join ",
        "telegramLink": "this channel",
        "telegram2": " to download latest updates.",
        "iostestflight1": "iOS users can also download the game through ",
        "iostestflight2": "Apple TestFlight",
        "iostestflight3": " to install the game without needing a computer.",
        "android": "Android",
        "guide": "Guide",
        "forgotLoginCode": "Forgot your login code?",
        "logout": "Sign out",
        "notLoggedIn": "Failed to load Google account information. Please refresh the page and sign in again.",
        "serverError": "A server error has occurred. Please try again later.",
        "support": "Email Support"
    },
    "ko": {
        "title": "Rhythm*IZ 신청",
        "incompatibleBrowser": "구글 로그인 오류가 발생하는 경우 크롬 브라우저에서 다시 시도해 주세요.",
        "email": "이메일",
        "downloadLink": "다운로드 링크",
        "registerButton": "신청",
        "registerButtonComplete": "신청 완료",
        "registrationComplete": "신청이 완료되었습니다! 신청한 구글 계정으로 위 링크를 열어주세요. 구글 드라이브 [공유 문서함]에서도 확인이 가능합니다.",
        "telegram1": "앱 다운로드 및 업데이트 알림은 ",
        "telegramLink": "텔레그램 채널",
        "telegram2": " 을 통해서 받을수도 있습니다.",
        "iostestflight1": "iOS 기기를 사용중이라면 ",
        "iostestflight2": "Apple TestFlight",
        "iostestflight3": " 을 통해 컴퓨터 없이 앱 설치가 가능합니다.",
        "android": "안드로이드",
        "forgotLoginCode": "연동코드를 잊어버리셨나요?",
        "guide": "도움말",
        "logout": "로그아웃",
        "notLoggedIn": "로그인 데이터를 확인하지 못했습니다. 페이지를 새로고침 후 다시 로그인 해 주세요.",
        "serverError": "서버 오류가 발생하였습니다. 점검 등의 사유로 실패할 수 있으니 잠시 후 다시 시도해 주세요.",
        "support": "문의하기"
    }
}
</i18n>

<template>
    <div style="width:100%;height:100%;color:white">
        <div class="backgroundImageContainer">
            <!-- <v-img class="backgroundImage" transition="image-fade" :src="require('../assets/rhythmiz/Iz_liveLoading_Background-min.jpeg')" lazy-src="https://firebasestorage.googleapis.com/v0/b/iz-one.appspot.com/o/rhythmiz%2FIz_liveLoading_Background.jpeg?alt=media&token=ddb6a0c0-eb09-49c7-b578-19960c58748c"></v-img> -->
            <v-img class="backgroundImage" :src="require('../assets/rhythmiz/Iz_liveLoading_Background-min.jpeg')"></v-img>
        </div>
        <v-container style="height:100%" class="container">
            <v-row>
                <v-col align="right">
                    <a href="mailto:iz12rhythm@gmail.com" style="text-decoration:none;"><v-btn text style="color:white;margin-right:10px;margin-bottom:3px;">{{ $t("support") }}</v-btn></a>
                    <v-icon color="white" style="display:inline-block;margin-bottom: 6px; margin-right:10px;">mdi-web</v-icon>
                    <v-select style="width:150px;display: inline-block;" color="white" v-model="locale" :items="locales" item-text="lang" item-value="code" single-line solo dense/>
                </v-col>
            </v-row>
            <v-row class="fill-height">
                <v-col cols="12" class="main-box">
                    <h2 style="margin-bottom:20px;margin-top:-150px">{{ $t("title") }}</h2>
                    <div v-show="!this.user.loggedIn">
                        <div id="firebase-auth-container"></div>
                        <span style="font-size:10pt;color:lightgray">{{ $t("incompatibleBrowser") }}</span>
                    </div>
                    <div class="logged-in" v-if="this.user.loggedIn">
                        <span>{{ $t("email") }}</span>
                        <h3>{{ this.user.data.email }}</h3>
                        <v-btn @click="apply" :disabled="this.applyButtonDisabled" class="rhythmiz-button" style="margin-top:20px;">
                        {{ applyButtonText }}&nbsp;<v-progress-circular v-show="this.applyLoading" width="2" size="20" color="white" indeterminate></v-progress-circular>
                        </v-btn>
                        <a href="/rhythmiz_forgot" v-show="this.url.length == 0" style="margin-top:14px">{{ $t("forgotLoginCode") }}</a>
                        <div style="margin-top:20px" v-show="this.url.length > 0">
                            <div>{{ $t("downloadLink") }}</div>
                            <a :href="this.url" target="_blank" style="white-space:pre-wrap;word-break:break-all;">{{ this.url }}</a>
                            <div><br/>
                                {{ $t("registrationComplete") }}
                                <br/><br/>
                                <span>{{ $t("telegram1") }}</span><a href="https://t.me/rhythmiz" target="_blank">{{ $t("telegramLink") }}</a><span>{{ $t("telegram2") }}</span><br/><br/>
                                <span>{{ $t("iostestflight1") }}</span><a href="/rhythmiz/testflight">{{ $t("iostestflight2") }}</a><span>{{ $t("iostestflight3") }}</span>
                                <br/><br/>
                                {{ $t("guide") }}: <a href="https://ssizone.notion.site/Android-3eb96403b1de42799cbe70aa9f835a4f" target="_blank" style="font-weight:bold">{{ $t("android") }}</a>&nbsp;&nbsp;&nbsp;<a href="https://ssizone.notion.site/iOS-acdbdd890d8849249bca10fb817fe6af" target="_blank" style="font-weight:bold">iOS</a>
                            </div>
                        </div>
                        <h4 style="margin-left:auto;margin-top:12px;cursor:pointer;" @click="logout">{{ $t("logout") }}</h4>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

  let firebaseui = require('firebaseui');
  import 'firebaseui/dist/firebaseui.css'
  import { getAuth, signOut } from "firebase/auth"
  import { GoogleAuthProvider } from "firebase/auth";
  import { mapGetters } from 'vuex';
  

  const auth = getAuth();
  const ui = new firebaseui.auth.AuthUI(auth);

  const axios = require("axios").default;

  export default {
    name: 'RhythmIZ',
    data(){
        return {
            applyLoading: false,
            applyButtonDisabled:false,
            url:"",
            alreadyExists:false,
            locale: this.$i18n.locale,
            locales: [
                { lang: "English", code: "en" },
                { lang: "한국어", code: "ko" }
            ]
        }
    },

    computed:{
        applyButtonText(){
            return this.$t("registerButton")
        },
        ...mapGetters({
            user: "user"
        })
    },

    watch: {
        locale(val){
            this.$i18n.locale = val;
        }
    },

    mounted(){
        if(this.$i18n.locale.length >= 2){
            let locale = this.$i18n.locale.substring(0, 2);
            if(locale == "en" || locale == "ko"){
                this.locale = locale;
            }else{
                this.locale = "en";
            }
        }else{
            this.locale = "en";
        }
        ui.start("#firebase-auth-container", {
            signInOptions: [
                GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD
            ],
            callbacks: {
                signInSuccessWithAuthResult(){
                    return false;
                }
            }
            
        });
    },

    methods: {
        logout(){
            signOut(auth).then(() => {
                this.url = "";
                ui.start("#firebase-auth-container", {
                    signInOptions: [
                        GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD
                    ],
                    callbacks: {
                        signInSuccessWithAuthResult(){
                            return false;
                        }
                    }
                    
                });
            });
        },

        apply(){
            if(!this.user.loggedIn){
                alert(this.$t("notLoggedIn"));
            }else{
                let form = new FormData();
                form.append("token", this.user.data.accessToken);
                this.applyButtonDisabled = true;
                this.applyLoading = true;
                axios.post("https://rhythmiz.wiz-one.space/group/add", form).then((response) => {
                    this.applyLoading = false;
                    this.applyButtonText = this.$t("registerButtonComplete");
                    if(response.data.success){
                        this.url = response.data.url;
                    }else{
                        alert(response.data.message);
                        this.applyButtonDisabled = false;
                    }
                }).catch(() => {
                    this.applyButtonDisabled = false;
                    alert(this.$t("serverError"));
                });
            }
        }
    }
  }
</script>

<style>
    a{
        color: pink !important;
    }
</style>

<style scoped>
.rhythmiz-button{
    background-color:#E1458B !important;
    color:white !important;
    font-weight:bold !important;
    font-size:12pt !important;
}

.backgroundImageContainer{
    z-index:0;
    position:absolute;
    width:100%;
    height:100%;
    object-fit: cover;
}

.backgroundImage{
    object-fit:cover;
    width:100%;
    height:100%;
    /* max-wdth:100%;
    height:100%; */
}

.container{
    overflow:scroll;
}

/* .container{
    display:flex;
    flex-direction:column;
    justify-content: center;
} */

.main-box{
    z-index:10;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height:100%;
}

.container *{
    z-index:10;
}

.logged-in{
    display:flex;
    flex-direction: column;
    background-color:rgba(255, 255, 255, 0.2);
    width:400px;
    padding:20px;
}
</style>